import service from '@/api';

// 获取应用版本
export const getAppVersion = () =>
  service.get('/geo/assistant/versions', {
    params: {
      aid: import.meta.env.VITE_APP_AID ?? 0,
    },
  });

export const getMaxAuthNum = () => service.get('/geo/auth/max_num');

export const getPlatformAuthNum = () => service.get('/geo/auth/platform');
